import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import * as _ from 'lodash';
import { Button } from '@material-ui/core';
import Layout from './Layout';
import { defaultModalSize } from './modalSize';
import { useLanguage } from '../../../context/language/language';
import useResponsive from '../../../utils/responsive';
import { Map } from '../../common';
import useDeliveryData from '../../common/hook/useDeliveryData';
import { getImageURL } from '../../../utils/getImageURL';
import useDeliveryControlFlow from '../../common/hook/useDeliveryControlFlow';
import { 
  CUSTOMER_ADDRESS, DELIVERY_TYPE_MENU, SELECT_STORE, STORE_WITH_OUT_AREA 
} from '../../../constant/deliveryFlow';
import configuration from '../../../configs/configuration';
import { selectLoginState } from '../../../store/authentication/selector';

const imgStoreNotFound = getImageURL('/icon/icon-store-not-found.svg');

const MapContainer = styled.div(() => ({
  marginTop: 0,
  marginBottom: 0,
  borderRadius: 23,
}));

const ImageView = styled('img')(({ theme }) => ({
  width: 140,
  height: 140,
  alignSelf: 'center',
}));

const Content = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  flexDirection: 'column',
}));

const MessageContent = styled('div')(() => ({
  minWidth: 170,
  wordWrap: 'break-word',
  textAlign: 'center',
  alignSelf: 'center',
  whiteSpace: 'pre-line'
}));

const Row = styled('div')(() => ({
  marginTop: 8,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
}));

const BtnChangeMethod = styled(Button)(({ theme, disabled }) => ({
  ...theme.radius.m,
  ...theme.fonts.header6,
  margin: 8,
  minWidth: 159,
  backgroundColor: theme.colors.green600,
  color: disabled ? theme.colors.grey500 : theme.colors.white,
  height: 44,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.colors.green400,
  },
}));

const BtnChangeAddress = styled(Button)(({ theme, disabled }) => ({
  ...theme.radius.m,
  ...theme.fonts.header6,
  margin: 8,
  backgroundColor: theme.colors.grey75,
  height: 44,
  minWidth: 159,
  textTransform: 'none',
}));

const StoreWithoutArea = ({
 onNext, onBack, onClose, modalRef 
}) => {
  const word = useLanguage();
  const deliveryData = useDeliveryData();
  const deliveryFlow = useDeliveryControlFlow();
  const { isMobile, isTablet } = useResponsive();
  const isLogin = useSelector(selectLoginState);
  const [latLng, setLatLng] = useState({});
  const [disableBtn, setDisableBtn] = useState(false);
  const [isHDND, setIsHDND] = useState();

  const { siteCode } = configuration;
  const isMY = siteCode.toLocaleUpperCase() === 'MY';
  
  useEffect(() => {
    if (!_.isEmpty(deliveryData) && _.isEmpty(latLng)) {
      const shippingAddress = _.get(
        deliveryData,
        'storeWithoutArea.shippingAddress',
        {}
      );
      const lat = _.get(shippingAddress, 'latitude', 0);
      const lng = _.get(shippingAddress, 'longitude', 0);
      setLatLng({ lat, lng });
    }
  }, [deliveryData]);

  useEffect(() => {
    const changeMethod = _.get(deliveryData, 'storeWithoutArea.changeMethod', false);
    setDisableBtn(changeMethod);
  }, []);

  useEffect(() => {
    if (!deliveryData?.loading) {
      const changeMethod = _.get(deliveryData, 'storeWithoutArea.changeMethod', false);
      setDisableBtn(changeMethod);
    }
  }, [deliveryData?.loading]);

  useEffect(() => {
    if (isHDND === undefined) {
      if (isMY) {
        setIsHDND(deliveryData?.deliveryMethod === 'HD' && deliveryData?.deliveryType === 'SFL');
      } else {
        setIsHDND(deliveryData?.deliveryMethod === 'HDND');
      }
    }
  }, [deliveryData?.deliveryMethod]);

  useEffect(() => {
    if ((disableBtn && deliveryData?.disableGoFresh) || (disableBtn && deliveryData?.disableHyper)) {
      deliveryFlow.setHideOnDemand(true);
    }
  }, [disableBtn, deliveryData?.disableGoFresh]);

  const onChangeAddress = () => {
    if (isMY) {
      deliveryFlow.pushPage(CUSTOMER_ADDRESS);
    } else if (isLogin) {
      deliveryFlow.replacePage(CUSTOMER_ADDRESS);
    } else {
      onBack();
    }
  };

  const onBackPage = () => {
    deliveryFlow.popToFirstPage(DELIVERY_TYPE_MENU);
  };

  const onChangeDeliveryMethod = () => {
    const storeType = _.get(deliveryData, 'activeStore.storeType', '');
    const filterStoreType = _.get(deliveryData, 'formData.filter.storeType', '');
    if (isHDND) {
      const shippingAddress = _.get(
        deliveryData,
        'storeWithoutArea.shippingAddress',
        {}
      );
      const data = _.get(deliveryData, 'formData', {});
      const activeDelivery = _.get(deliveryData, 'activeDelivery', {});
      const formData = {
        ...data,
        shippingAddress,
        activeData: { activeDelivery },
      };
      deliveryFlow.setStoreWithoutAreaMethodChange(true);
      deliveryFlow.setDeliveryTypeGoFresh("OD", "HD", shippingAddress);
      deliveryFlow.deliveryPageChange({
        page: SELECT_STORE,
        fromPage: STORE_WITH_OUT_AREA
      });
    } else if (storeType === 'go_fresh' && isMobile) {
      if (filterStoreType === 'go_fresh') {
        deliveryFlow.setDisableGoFresh(true);
      } else {
        deliveryFlow.setDisableHyper(true);
      }
      deliveryFlow.setStoreWithoutAreaMethodChange(true);
      deliveryFlow.openDeliveryDialog(DELIVERY_TYPE_MENU);
    } else if (storeType === 'hyper' && isMobile) {
      deliveryFlow.setDisableHyper(true);
      if (filterStoreType === 'hyper') {
        deliveryFlow.setDisableHyper(true);
      } else {
        deliveryFlow.setDisableGoFresh(true);
      }
      deliveryFlow.setStoreWithoutAreaMethodChange(true);
      deliveryFlow.openDeliveryDialog(DELIVERY_TYPE_MENU);
    } else {
      deliveryFlow.setStoreWithoutAreaMethodChange(true);
      deliveryFlow.setHideOnDemand(true);
      deliveryFlow.setFromWidget(true);
      deliveryFlow.openDeliveryDialog(DELIVERY_TYPE_MENU);
    }
  };
  const descMessage = isHDND ? word('Store.Error.Notfound') : word('Store.Error.OnDemand.Notfound');
  return (
    <Layout
      title={word('StoreSelection.Title')}
      onBack={onBackPage}
      onClose={() => {
        // const delivery = _.get(deliveryData, 'activeDelivery', {});
        // const shippingAddress = _.get(deliveryData, 'shippingAddress', {});
        // deliveryFlow.clearStoreWithoutArea({ ...delivery, shippingAddress });
        onClose();
      }}
      width={
        isTablet
          ? defaultModalSize.tablet.width
          : defaultModalSize.desktop.width
      }
      height={
        isTablet
          ? defaultModalSize.tablet.height
          : defaultModalSize.desktop.height
      }
      backButtonShown={deliveryFlow.stackSize > 1}
    >
      <>
        {
          !_.isEmpty(latLng) && (
            <MapContainer>
              <Map
                latLng={latLng}
                controlOptions={{ draggable: false }}
                zoom={15}
                disableInfo
              />
            </MapContainer>
          )
        }
        <Content>
          <ImageView src={imgStoreNotFound} />
          <MessageContent>
            {descMessage.replace(/\\n/g, '\n')}
          </MessageContent>
          {!disableBtn && (
            <Row style={isMobile ? { borderTop: 'solid 1px #E0E0E0', paddingTop: 12, marginTop: 25 } : { paddingTop: 12 }}>
              <BtnChangeAddress
                id="btn-change-address"
                data-cta-name-en="change-address"
                data-cta-name-th="เปลี่ยนที่อยู่"
                data-cta-type="Button"
                onClick={onChangeAddress}
              >
                {word('Store.Error.OutOfServiceArea.Button')}
              </BtnChangeAddress>
              {
                !isMY && (
                  <BtnChangeMethod
                    id="btn-delivery-method"
                    data-cta-name-en="btn-delivery-method"
                    data-cta-name-th="เปลี่ยนการจัดส่ง"
                    data-cta-type="Button"
                    onClick={onChangeDeliveryMethod}
                  >
                    {isHDND ? word('Store.Error.NextDay.Notfound.Button') : word('Store.Error.OnDemand.Notfound.Button')}
                  </BtnChangeMethod>
                )
              }
            </Row>
          )}
        </Content>
      </>
    </Layout>
  );
};

export default StoreWithoutArea;
